import React, {Component, ReactNode} from "react"

import withTabStatus from "@irati/utils/withTabStatus"

import {getConfetti, fireConfetti} from "./helpers/confetti"

import {Container} from "./styled"

interface Props {
  active?: boolean,
  children: ReactNode,
  isTabVisible: boolean
}

class Confetti extends Component<Props> {
  static defaultProps = {
    active: true
  }

  creator: number | null = null
  container: HTMLDivElement | null = null

  timers = []

  confettize = () => {
    const {isTabVisible} = this.props

    const {width, height} = this.container!.getBoundingClientRect()

    if (isTabVisible) {
      const confetti = getConfetti(width, height)
      const timers = fireConfetti(this.container, confetti)

      this.timers = this.timers.concat(timers)
    }
  }

  deconfettize = () => {
    if (this.creator) {
      window.clearInterval(this.creator)
    }
    while (this.timers.length > 0) {
      const timer = this.timers.pop()
      window.clearTimeout(timer)
    }
  }

  componentDidMount() {
    if (this.props.active) {
      this.confettize()
      this.creator = window.setInterval(this.confettize, 800)
    }
  }

  componentDidUpdate() {
    if (!this.props.active) {
      this.deconfettize()
    }
  }

  componentWillUnmount() {
    this.deconfettize()
  }

  render() {
    const {children, active} = this.props
    return (
      <Container
        ref={(c) => {
          this.container = c
        }}
        active={active}>
        {children}
      </Container>
    )
  }
}

export default withTabStatus(Confetti)
